export const column = [
  { key: '1', headerName: 'S.No', field: 'S.No', hide: false, width: 70 },
  // { key: '2', headerName: 'City Code', field: 'id', hide: false, width: 130 },
  { key: '3', headerName: 'City Name', field: 'name', hide: false, width: 210 },
  { key: '4', headerName: 'Sub Zone Name', field: 'subzonel_name', hide: false, width: 250 },
  { key: '5', headerName: 'Zone', field: 'zonel_name', hide: false, width: 250 },
  { key: '6', headerName: 'State', field: 'state_name', hide: false, width: 250 },
  { key: '7', headerName: 'Status', field: 'status', hide: false, width: 120 },
];
